import { batch, connect } from 'react-redux';
import { Dispatch } from '@reduxjs/toolkit';

import { PDPDeliveryTacticalImprovements } from 'src/constants/featureFlags';
import { ReduxApplicationState } from 'src/redux/combinedReducer';
import {
  actions as deliveryZoneOptionsActions,
  SelectCountryPayload,
  selectDecoratedDeliveryOptions,
  selectDeliveryZoneOptionsIsLoading,
  selectSelectedCountry,
  selectSelectedZone,
} from 'src/redux/deliveryZoneOptions';
import { selectHasSelectedCountriesDeliveryOnly, selectHasUKDeliveryOnly } from 'src/redux/product';
import { DeliveryBlock } from '../components/DeliveryBlock';
import {
  selectGroupedCountriesForDropdown,
  selectProductDeliveryOptionsForZone,
} from '../modules/selectors';

const mapStateToProps = (state: ReduxApplicationState) => ({
  groupedCountries: selectGroupedCountriesForDropdown(state),
  deliveryOptions: selectDecoratedDeliveryOptions(state),
  deliveryOptionsPlaceholderItems: selectProductDeliveryOptionsForZone(state),
  selectedCountry: `${selectSelectedCountry(state)}|${selectSelectedZone(state)}`,
  hasUkDeliveryOnly: selectHasUKDeliveryOnly(state),
  hasSelectedCountriesDeliveryOnly: selectHasSelectedCountriesDeliveryOnly(state),
  isLoading: selectDeliveryZoneOptionsIsLoading(state),
  displayDeliveryProviders:
    state.userConfiguration.featureFlags?.[PDPDeliveryTacticalImprovements.NAME] ===
    PDPDeliveryTacticalImprovements.DISPLAY_DELIVERY_PROVIDERS,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onCountryChange: (payload: SelectCountryPayload) =>
    batch(() => {
      dispatch(deliveryZoneOptionsActions.setSelectedZone(payload.selectedZone));
      dispatch(deliveryZoneOptionsActions.setSelectedCountry(payload));
    }),
});

export const DeliveryBlockContainer = connect(mapStateToProps, mapDispatchToProps)(DeliveryBlock);
